import locale from "localization";
import styles from "./shift-records-details-cash-and-non-cash.module.scss";
import { Text, TextField, Title } from "components/commons";
import { cashOnHandColumn } from "./shift-records-details-cash-non-cash-column";
import { formatAmount, formatAmountV2 } from "utils";
import Big from "big.js";
import { FormMode } from "enums";
import { safeDropAnchorId } from "../shift-records-details-completion";

const isNumericString = (val) => {
  return typeof val === "string" && /^-?\d+(\.\d+)?$/.test(val);
};

const trimLeadingZeros = (val) => {
  if (typeof val !== "string") return val;
  if (val === "-" || val === "") return val;
  const trimmed = val.replace(/^(-?)0+(?!$)/, "$1");
  return trimmed === "-0" ? "0" : trimmed;
};

const ShiftDetailsCashOnHand = ({ safeDrop, setSafeDrop, pageMode }) => {
  const updateRow = (index, rawValue) => {
    const newSafeDrop = [...safeDrop];
    const isError = rawValue === "-";
    const parsed = rawValue === "" || isNaN(Number(rawValue)) ? 0 : Number(rawValue);
    const newTotal = Number(Big(parsed).add(newSafeDrop[index].safeDropItem));
    newSafeDrop[index] = {
      ...newSafeDrop[index],
      safeDrop: rawValue,
      total: newTotal,
      totalAmount: Number(Big(newSafeDrop[index].denomination).mul(newTotal)),
      error: isError,
    };
    setSafeDrop(newSafeDrop);
  };

  return (
    <>
      <Title small black>
        {locale.cashOnHand}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        {safeDrop && safeDrop.length > 0 && (
          <div style={{ padding: "20px" }}>
            <table className={styles.table}>
              <thead>
                <tr>
                  {cashOnHandColumn.map((item, i) => {
                    return (
                      <th key={i} style={item.width ? { width: item.width } : undefined}>
                        {item.text}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {safeDrop.map((item, i) => {
                  let denomination = formatAmount(item.denomination);
                  if (item.key === "twenty") {
                    denomination = `${formatAmount(item.denomination)} bills`;
                  } else if (item.key === "twentyCoins") {
                    denomination = `${formatAmount(item.denomination)} coins`;
                  } else if (item.key === "coinAmount") {
                    denomination = locale.coins;
                  }
                  return (
                    <tr key={i}>
                      <td>{denomination}</td>
                      <td>
                        <Text className={styles.content}>{item.safeDropItem}</Text>
                      </td>
                      <td id={safeDropAnchorId(item.key)} data-incomplete={Boolean(item.error)}>
                        {pageMode === FormMode.Edit ? (
                          <>
                            <TextField
                              error={item.error}
                              value={item.safeDrop}
                              onChange={(_, { value }) => {
                                if (isNumericString(value) || value === "" || value === "-") {
                                  updateRow(i, value === "" ? "" : trimLeadingZeros(value));
                                }
                              }}
                              onBlur={(_, { value }) => {
                                updateRow(i, value === "" ? 0 : trimLeadingZeros(value));
                              }}
                            />
                            {item.error && (
                              <Text className={styles.fieldError}>
                                {locale.pleaseEnterAValidAmount}
                              </Text>
                            )}
                          </>
                        ) : (
                          <Text className={styles.content}>{item.safeDrop}</Text>
                        )}
                      </td>
                      <td>
                        <Text className={styles.content}>{Number(Big(item.total))}</Text>
                      </td>
                      <td>
                        <Text className={styles.content}>
                          {formatAmountV2(item.totalAmount, item.totalAmount < 0)}
                        </Text>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsCashOnHand;
